<template>
  <div class="container">
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
        <h1 class="titulo m-t-2 m-t-3-md">Comercio exterior de energéticos</h1>
        <hr>
        <p class="texto-principal">Los movimientos comerciales de los energéticos entre distintos países y sus mercados constituyen el comercio exterior de los energéticos. Éste está sujeto a regulaciones, acuerdos y convenios comerciales establecidos.</p>
        <p class="texto-principal">La importación abarca energéticos primarios y secundarios que se encuentran localizados fuera de las fronteras y que se incorporan al país para formar parte de la oferta total de energía. Para el caso de las gasolinas y naftas se consideran las importaciones de metil-terbutil-éter (mtbe).</p>
        <p class="texto-principal">A la cantidad de energía primaria y secundaria que se destina para su uso fuera del territorio nacional se le llama exportación (Sener, 2020).</p>
      </div>

      <div>
        <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Importación</h3>
            <p class="texto-notas">Importación en peta joules (PJ). Datos para 2020.</p>
          </div>
          <div class="contenido">
            <div class="graficaImportacion" ref="graficaImportacion">
            </div>
            <p class="texto-notas">Elaboración propia a partir de datos del SIM de CENACE y PRODESEN.</p>
          </div>
        </div>

        <br>

        <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Exportación</h3>
            <p class="texto-notas">Exportación en peta joules (PJ). Datos para 2020.</p>
          </div>
          <div class="contenido">
            <div class="graficaExportacion" ref="graficaExportacion">
            </div>
            <p class="texto-notas">Elaboración propia a partir de datos del SIM de CENACE y PRODESEN.</p>
          </div>
          <div class="notas">
              
            </div>
        </div>


        <br/>


      <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Importación 2015-2020</h3>
            <p class="texto-notas">Importación en peta joules (PJ)</p>
          </div>
          <div class="contenido">
            <div class="barrasImportacion" ref="barrasImportacion">
            </div>
            <p class="texto-notas">Elaboración propia a partir de datos del SIM de CENACE y PRODESEN.</p>
          </div>
          <div class="notas">
              
            </div>
        </div>

      <br/>

      <div class="tarjeta-contenedor">
        <div class="encabezado">
          <h3>Exportación 2015-2020</h3>
          <p class="texto-notas">Importación en peta joules (PJ)</p>
        </div>
        <div class="contenido">
          <div class="barrasExportacion" ref="barrasExportacion">
          </div>
          <p class="texto-notas">Elaboración propia a partir de datos del SIM de CENACE y PRODESEN.</p>
        </div>
        <div class="notas">
            
          </div>
      </div>

      

    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
          <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
          <ul class="lista-referencias">
            <li><strong><em>Palacios, R., Valles, X., Solís, A., Becerril, A. S., Rodríguez, F., Martínez, H., Rodríguez, J. I., De La Pascua, L. E., Pleitez, R. O., Hernández, F., & Zamudio, J. P. (2022).</em></strong> Estudio del Balance Nacional de Energía 2020. Consejo Nacional de Ciencia y Tecnología (Conacyt), Plataforma Nacional Energía Ambiente y Sociedad (Planeas), Programa Nacional Estratégico de Energía y Cambio Climático (Pronaces-ecc). <a href="https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/" target="_blank">https://conacyt.mx/publicaciones-conacyt/energia-y-cambio-climatico/</a></li>
          </ul>
          
    </div>

  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";

  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
    
    },
    data: function () {
      return {
        datosImportacion:datosImportacion,
        datosExportacion:datosExportacion,
        impDatos: impDatos,
        impVariables: impVariables,
        expDatos: expDatos,
        expVariables: expVariables
      }   
    },
    mounted() {

        let chart = am4core.create(this.$refs.graficaImportacion, am4charts.PieChart);
        //chart.paddingLeft = 120;
        //chart.paddingRight = 120;
        chart.responsive.enabled = true;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "BalanceImporacion";
        chart.exporting.useWebFonts = false;
        chart.language.locale = am4lang_es_ES;
        chart.language.locale["_decimalSeparator"] = ".";
        chart.language.locale["_thousandSeparator"] = ","; 

        chart.fontSize = 12;
        

        chart.legend = new am4charts.Legend();
        chart.legend.useDefaultMarker = true;
        chart.legend.scrollable = true;
        chart.legend.maxHeight = 150;
        
        let marker1 = chart.legend.markers.template.children.getIndex(0);
        marker1.cornerRadius(12, 12, 12, 12);
        marker1.strokeWidth = 2;
        marker1.strokeOpacity = 1;
        marker1.stroke = am4core.color("#fff");
        
        chart.data = datosImportacion;

        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "cantidad";
        pieSeries.dataFields.category = "nombre";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;


        pieSeries.alignLabels = true;
        pieSeries.labels.template.bent = true;
        pieSeries.labels.template.radius = 3;
        pieSeries.labels.template.padding(0,0,0,0);
        pieSeries.labels.template.hideOversized = true;
       
        pieSeries.slices.template.adapter.add("fill", function (fill, target) {
            return target.dataItem.dataContext["color"];
        });

        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
        
        chart.hiddenState.properties.radius = am4core.percent(0);

        this.chart = chart;

        //Exportación

        let chart2 = am4core.create(this.$refs.graficaExportacion, am4charts.PieChart);
        //chart2.paddingLeft = 120;
        //chart2.paddingRight = 120;
        chart2.responsive.enabled = true;
        chart2.exporting.menu = new am4core.ExportMenu();
        chart2.exporting.filePrefix = "BalanceExportacion";
        chart2.language.locale = am4lang_es_ES;
        chart2.language.locale["_decimalSeparator"] = ".";
        chart2.language.locale["_thousandSeparator"] = ","; 

        chart2.fontSize = 12;

        chart2.legend = new am4charts.Legend();
        chart2.legend.useDefaultMarker = true;
        chart2.legend.scrollable = true;
        chart2.legend.maxHeight = 150;
        let marker2 = chart2.legend.markers.template.children.getIndex(0);
        marker2.cornerRadius(12, 12, 12, 12);
        marker2.strokeWidth = 2;
        marker2.strokeOpacity = 1;
        marker2.stroke = am4core.color("#fff");

        
        chart2.data = datosExportacion;

        // Add and configure Series
        let pieSeries2 = chart2.series.push(new am4charts.PieSeries());
        pieSeries2.dataFields.value = "cantidad";
        pieSeries2.dataFields.category = "nombre";
        pieSeries2.slices.template.stroke = am4core.color("#fff");
        pieSeries2.slices.template.strokeOpacity = 1;

        pieSeries2.alignLabels = true;
        pieSeries2.labels.template.bent = true;
        pieSeries2.labels.template.radius = 3;
        pieSeries2.labels.template.padding(0,0,0,0);
        pieSeries2.labels.template.hideOversized = true;

        pieSeries2.slices.template.adapter.add("fill", function (fill, target) {
            return target.dataItem.dataContext["color"];
        });

        // This creates initial animation
        pieSeries2.hiddenState.properties.opacity = 1;
        pieSeries2.hiddenState.properties.endAngle = -90;
        pieSeries2.hiddenState.properties.startAngle = -90;

        chart2.hiddenState.properties.radius = am4core.percent(0);

        this.chart2 = chart2;

        //Gráfica: Comercio exterior de energéticos - Importación
        let chart3 = am4core.create(this.$refs.barrasImportacion, am4charts.XYChart);
        chart3.responsive.enabled = true;
        chart3.exporting.menu = new am4core.ExportMenu();
        chart3.exporting.filePrefix = "BalanceImportacion2015-2020";
        chart3.language.locale = am4lang_es_ES;
        chart3.language.locale["_decimalSeparator"] = ".";
        chart3.language.locale["_thousandSeparator"] = ","; 
        chart3.paddingLeft = 20;
        chart3.paddingRight = 50;
        chart3.fontSize = 12;

        chart3.data = impDatos;

        // Create axes
        let categoryAxis3 = chart3.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis3.dataFields.category = "a";
        categoryAxis3.renderer.grid.template.location = 0;


        let valueAxis3 = chart3.yAxes.push(new am4charts.ValueAxis());
        valueAxis3.renderer.inside = false;
        valueAxis3.min = 0;
        //valueAxis3.max = 1000;
        valueAxis3.title.text = "Consumo (PJ)";
        valueAxis3.strictMinMax = true;
        valueAxis3.calculateTotals = true;
        valueAxis3.renderer.minWidth = 10;
        valueAxis3.fontSize = 11;

        // Create series
        function createSeries3(field, name, color) {
          
          // Set up series
          let series = chart3.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "a";
          series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          series.tooltip.background.fill = am4core.color(color);
          series.stroke = am4core.color(color);
          // Make it stacked
          series.stacked = true;
          series.fillOpacity = 0.8;
          series.strokeWidth = 1;
          
          // Configure columns
          series.columns.template.width = am4core.percent(60);
          series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
          
          // Add label
          let bullet = series.bullets.push(new am4charts.LabelBullet());
          bullet.interactionsEnabled = false;
          bullet.label.hideOversized = true;
          bullet.label.text = "{valueY.totalPercent.formatNumber('#.0')}%";
          bullet.locationY = 0.5;
          bullet.label.fill = am4core.color("#ffffff");
          bullet.label.fontSize = 11;
          
          return series;
        }

        for(var i=0; i<impVariables.length; i++)
        {
          let impVar = impVariables[i];
          createSeries3(impVar.id, impVar.nombre,impVar.color);
        }

        // Legend
        chart3.legend = new am4charts.Legend();
        chart3.legend.useDefaultMarker = true;
        chart3.legend.scrollable = true;
        chart3.legend.maxHeight = 150;
        let marker3 = chart3.legend.markers.template.children.getIndex(0);
        marker3.cornerRadius(12, 12, 12, 12);
        marker3.strokeWidth = 2;
        marker3.strokeOpacity = 1;
        marker3.stroke = am4core.color("#fff");

        this.chart3 = chart3;


        //Gráfica: Comercio exterior de energéticos - Exportación
        let chart4 = am4core.create(this.$refs.barrasExportacion, am4charts.XYChart);
        chart4.responsive.enabled = true;
        chart4.exporting.menu = new am4core.ExportMenu();
        chart4.exporting.filePrefix = "BalanceExportacion2015-2020";
        chart4.language.locale = am4lang_es_ES;
        chart4.language.locale["_decimalSeparator"] = ".";
        chart4.language.locale["_thousandSeparator"] = ","; 
        chart4.paddingLeft = 20;
        chart4.paddingRight = 50;
        chart4.fontSize = 12;

        chart4.data = expDatos;

        // Create axes
        let categoryAxis4 = chart4.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis4.dataFields.category = "a";
        categoryAxis4.renderer.grid.template.location = 0;


        let valueAxis4 = chart4.yAxes.push(new am4charts.ValueAxis());
        valueAxis4.renderer.inside = false;
        valueAxis4.min = 0;
        //valueAxis4.max = 1000;
        valueAxis4.title.text = "Exportación (PJ)";
        valueAxis4.strictMinMax = true;
        valueAxis4.calculateTotals = true;
        valueAxis4.renderer.minWidth = 10;
        valueAxis4.fontSize = 11;

        // Create series
        function createSeries4(field, name, color) {
          
          // Set up series
          let series = chart4.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "a";
          series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          series.tooltip.background.fill = am4core.color(color);
          series.stroke = am4core.color(color);
          // Make it stacked
          series.stacked = true;
          series.fillOpacity = 0.8;
          series.strokeWidth = 0;
          
          // Configure columns
          series.columns.template.width = am4core.percent(60);
          series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";
          
          // Add label
          let bullet = series.bullets.push(new am4charts.LabelBullet());
          bullet.interactionsEnabled = false;
          bullet.label.hideOversized = true;
          bullet.label.text = "{valueY.totalPercent.formatNumber('#.0')}%";
          bullet.locationY = 0.5;
          bullet.label.fill = am4core.color("#ffffff");
          bullet.label.fontSize = 11;
          
          return series;
        }

        for(var i=0; i<expVariables.length; i++)
        {
          let expVar = expVariables[i];
          createSeries4(expVar.id, expVar.nombre,expVar.color);
        }

        // Legend
        chart4.legend = new am4charts.Legend();
        chart4.legend.useDefaultMarker = true;
        chart4.legend.scrollable = true;
        chart4.legend.maxHeight = 150;
        let marker4 = chart4.legend.markers.template.children.getIndex(0);
        marker4.cornerRadius(12, 12, 12, 12);
        marker4.strokeWidth = 2;
        marker4.strokeOpacity = 1;
        marker4.stroke = am4core.color("#fff");

        this.chart4 = chart4;

    },
    methods: {
      tooltipProduccion(d) {
        return `Consumo<br>${d.a}: ${
          this.prodVariables.find(v => v.id === d.key).nombre
        } | <b>${d[d.key].toFixed(2)}</b> (${((d[d.key] / Object.values(d)
          .filter(f => parseFloat(f)).reduce((a,b) => a+b)
        ) * 100).toFixed(2)}%)`
      },
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }

      if (this.chart2) {
        this.chart2.dispose();
      }

      if (this.chart3) {
        this.chart3.dispose();
      }

      if (this.chart4) {
        this.chart4.dispose();
      }
    },
  }


  const datosImportacion = [
  {
    "nombre": "Coque de petróleo",
    "cantidad": 113.55,
    "color": "#434343"
  },
  {
    "nombre": "Carbón",
    "cantidad": 21.79,
    "color": "#85200c"
  },
  {
    "nombre": "GLP",
    "cantidad": 283,
    "color": "#c9daf8"
  },
  {
    "nombre": "Coque de carbón",
    "cantidad": 27.2,
    "color": "#cc4125"
  },
  {
    "nombre": "Gasolina",
    "cantidad": 694.31,
    "color": "#cccccc"
  },
  {
    "nombre": "Queroseno",
    "cantidad": 45.81,
    "color": "#999999"
  },
  {
    "nombre": "Diésel",
    "cantidad": 436.23,
    "color": "#b7b7b7"
  },
  {
    "nombre": "Combustóleo",
    "cantidad": 20.22,
    "color": "#666666"
  },
  {
    "nombre": "Gas seco",
    "cantidad": 1890.44,
    "color": "#6d9eeb"
  },
  {
    "nombre": "Eléctricidad",
    "cantidad": 35.87,
    "color": "#00ff00"
  }
];

const datosExportacion = [
  {
    "nombre": "Coque de petróleo",
    "cantidad": 0.07,
    "color": "#434343"
  },
  {
    "nombre": "Carbón",
    "cantidad": 0.09,
    "color": "#85200c"
  },
  {
    "nombre": "Petróleo",
    "cantidad": 2509.23,
    "color": "#000000"
  },
 
  {
    "nombre": "GLP",
    "cantidad": 1.21,
    "color": "#c9daf8"
  },
  {
    "nombre": "Gasolina",
    "cantidad": 23.49,
    "color": "#cccccc"
  },
  {
    "nombre": "Diésel",
    "cantidad": 36.6,
    "color": "#b7b7b7"
  },
  {
    "nombre": "Combustóleo",
    "cantidad": 262.88,
    "color": "#666666"
  },
  {
    "nombre": "Gas seco",
    "cantidad": 2.66,
    "color": "#6d9eeb"
  },
  {
    "nombre": "Eléctricidad",
    "cantidad": 21.44,
    "color": "#00ff00"
  }
];

const impDatos = [
  {
    "a": "2015",
    "Carbon": 223.23,
    "Petroleo": 0,
    "CoqueCarbon": 13.87,
    "CoquePetroleo": 90.54,
    "GLP": 158.4,
    "Gasolina": 810.82,
    "Queroseno": 50.35,
    "Diesel": 339.4,
    "Combustoleo": 40.43,
    "GasSeco": "1,168.46",
    "Electricidad": 8.8
  },
  {
    "a": "2016",
    "Carbon": 239.85,
    "Petroleo": 0,
    "CoqueCarbon": 29.41,
    "CoquePetroleo": 110.45,
    "GLP": 206.48,
    "Gasolina": 978.84,
    "Queroseno": 72.33,
    "Diesel": 415.58,
    "Combustoleo": 73.63,
    "GasSeco": "1,855.21",
    "Electricidad": 12.46
  },
  {
    "a": "2017",
    "Carbon": 301.22,
    "Petroleo": 0,
    "CoqueCarbon": 31.53,
    "CoquePetroleo": 140.2,
    "GLP": 224.87,
    "Gasolina": "1,061.00",
    "Queroseno": 91.19,
    "Diesel": 559.82,
    "Combustoleo": 92.49,
    "GasSeco": "1,906.90",
    "Electricidad": 8.39
  },
  {
    "a": "2018",
    "Carbon": 268.67,
    "Petroleo": 8.57,
    "CoqueCarbon": 19.18,
    "CoquePetroleo": 151.56,
    "GLP": 248.94,
    "Gasolina": "1,262.58",
    "Queroseno": 121.7,
    "Diesel": 658.1,
    "Combustoleo": 87.56,
    "GasSeco": "2,191.16",
    "Electricidad": 14.19
  },
  {
    "a": "2019",
    "Carbon": 275.15,
    "Petroleo": 0,
    "CoqueCarbon": 32.33,
    "CoquePetroleo": 117.19,
    "GLP": 233.63,
    "Gasolina": "1,128.09",
    "Queroseno": 114.69,
    "Diesel": 572.06,
    "Combustoleo": 103.14,
    "GasSeco": "2,213.00",
    "Electricidad": 14.07
  },
  {
    "a": "2020",
    "Carbon": 21.79,
    "Petroleo": 0,
    "CoqueCarbon": 27.2,
    "CoquePetroleo": 113.55,
    "GLP": 283,
    "Gasolina": 694.31,
    "Queroseno": 45.81,
    "Diesel": 436.23,
    "Combustoleo": 20.22,
    "GasSeco": "1,890.44",
    "Electricidad": 35.87
  }
];


const impVariables = [
  {"id":"Carbon","nombre":"Carbón","color":"#85200c"},
  {"id":"Petroleo","nombre":"Petróleo","color":"#000000"},
  {"id":"CoqueCarbon","nombre":"Coque de carbón","color":"#cc4125"},
  {"id":"CoquePetroleo","nombre":"Coque de petróleo","color":"#434343"},
  {"id":"GLP","nombre":"GLP","color":"#c9daf8"},
  {"id":"Gasolina","nombre":"Gasolina","color":"#cccccc"},
  {"id":"Queroseno","nombre":"Queroseno","color":"#999999"},
  {"id":"Diesel","nombre":"Diésel","color":"#b7b7b7"},
  {"id":"Combustoleo","nombre":"Combustóleo","color":"#666666"},
  {"id":"GasSeco","nombre":"Gas seco","color":"#6d9eeb"},
  {"id":"Electricidad","nombre":"Electricidad","color":"#00ff00"}
];

const expDatos = [
  {
    "a": "2015",
    "Carbon": 0.08,
    "Petroleo": "2,631.49",
    "Condensados": 2.66,
    "CoqueCarbon": 0,
    "CoquePetroleo": 0,
    "GLP": 0.03,
    "Gasolina": 118.81,
    "Diesel": 15.71,
    "Combustóleo": 295.47,
    "NoEnergeticos": 2.71,
    "GasSeco": 4.94,
    "Electricidad": 32.98
  },
  {
    "a": "2016",
    "Carbon": 0.08,
    "Petroleo": "2,685.64",
    "Condensados": 0,
    "CoqueCarbon": 0,
    "CoquePetroleo": 0.01,
    "GLP": 6.76,
    "Gasolina": 103.4,
    "Diesel": 0,
    "Combustóleo": 272.12,
    "NoEnergeticos": 0.87,
    "GasSeco": 1.04,
    "Electricidad": 31
  },
  {
    "a": "2017",
    "Carbon": 0.08,
    "Petroleo": "2,609.26",
    "Condensados": 0,
    "CoqueCarbon": 0.07,
    "CoquePetroleo": 0.03,
    "GLP": 8.6,
    "Gasolina": 84.74,
    "Diesel": 0,
    "Combustóleo": 242.11,
    "NoEnergeticos": 0.16,
    "GasSeco": 1.5,
    "Electricidad": 28.35
  },
  {
    "a": "2018",
    "Carbon": 0.14,
    "Petroleo": "2,681.70",
    "Condensados": 0,
    "CoqueCarbon": 1.18,
    "CoquePetroleo": 0.1,
    "GLP": 2.88,
    "Gasolina": 77.04,
    "Diesel": 8.94,
    "Combustóleo": 224.02,
    "NoEnergeticos": 0,
    "GasSeco": 7.94,
    "Electricidad": 26.65
  },
  {
    "a": "2019",
    "Carbon": 0.14,
    "Petroleo": "2,465.32",
    "Condensados": 0,
    "CoqueCarbon": 0.01,
    "CoquePetroleo": 0.09,
    "GLP": 1.4,
    "Gasolina": 64.68,
    "Diesel": 27.13,
    "Combustóleo": 168.52,
    "NoEnergeticos": 0,
    "GasSeco": 1.4,
    "Electricidad": 18.76
  },
  {
    "a": "2020",
    "Carbon": 0.09,
    "Petroleo": "2,509.23",
    "Condensados": 0,
    "CoqueCarbon": 0,
    "CoquePetroleo": 0.07,
    "GLP": 1.21,
    "Gasolina": 23.49,
    "Diesel": 36.6,
    "Combustóleo": 262.88,
    "NoEnergeticos": 0,
    "GasSeco": 2.66,
    "Electricidad": 21.44
  }
];

const expVariables = [
  {"id":"Carbon","nombre":"Carbón","color":"#85200c"},
  {"id":"Petroleo","nombre":"Petróleo","color":"#000000"},
  {"id":"Condensados","nombre":"Condensados","color":"#ff0000"},
  {"id":"CoqueCarbon","nombre":"Coque de carbón","color":"#cc4125"},
  {"id":"CoquePetroleo","nombre":"Coque de petróleo","color":"#434343"},
  {"id":"GLP","nombre":"GLP","color":"#c9daf8"},
  {"id":"Gasolina","nombre":"Gasolina","color":"#cccccc"},
  {"id":"NoEnergeticos","nombre":"No energéticos","color":"#ff00ff"},
  {"id":"Diesel","nombre":"Diésel","color":"#b7b7b7"},
  {"id":"Combustoleo","nombre":"Combustóleo","color":"#666666"},
  {"id":"GasSeco","nombre":"Gas seco","color":"#6d9eeb"},
  {"id":"Electricidad","nombre":"Electricidad","color":"#00ff00"},
];

</script>
<style scoped lang="scss">

  .graficaImportacion{
    width: 100%;
    height: 500px;
  }

  .graficaExportacion{
    width: 100%;
    height: 500px;
  }

  .barrasImportacion{
    width: 100%;
    height: 500px;
  }

  .barrasExportacion {
    width: 100%;
    height: 500px;
  }
</style>
